import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from "react-router-dom";
import Api, { errorToast } from 'utils/api/Api';

export const HomeMainActivity = () => {
    const navigate = useNavigate();
    const config = useSelector((state) => state.config);
    const auth = useSelector((state) => state.auth);
    const { school } = useParams();

    const createRumiTokenMutate = useMutation({
        mutationFn: () => Api.get(`/api/auth/create-rumi-token`),
        onSuccess: (res) =>{
            window.open(`http://readingzone.co.kr/auth.php?user_id=gne_${auth.userid}_${auth.id}&name=${encodeURIComponent(auth.name)}_${auth.id}&grade=${auth.grade}&token=${encodeURIComponent(res.data)}`);
        },
        onError: errorToast,
    });

    const moveRumi = () => {
        if (!auth.authenticated) {
            navigate(`/${school}/signin`);
            return;
        }
        if (createRumiTokenMutate.isPending) return;
        createRumiTokenMutate.mutate();
    }

    return (
        <div className="activity">
            {config.useRumi ?
                <button onClick={moveRumi}>
                    <img src={`${process.env.PUBLIC_URL}/static/images/main/main_section1_fairytale.png`} alt="교과 연계 웹동화" />
                </button>
                : // 루미를 사용하지 않으면 나도 작가다 표시
                <Link to={`/${school}/userbook`}>
                    <img src={`${process.env.PUBLIC_URL}/static/images/main/main_section1_userbook.png`} alt="나도 작가다" />
                </Link>
            }
        </div>
    );
}